import { badgeById } from '@accra/shared';
import { el } from './el';

/** A few small badge icons (with the badge name on hover), for next to a driver's name. */
export function badgeIcons(ids: readonly string[] | undefined): HTMLElement {
  const wrap = el('span', 'badge-icons');
  for (const id of ids ?? []) {
    const badge = badgeById(id);
    if (!badge) continue;
    const icon = el('span', 'badge-icon', badge.icon);
    icon.title = `${badge.name}: ${badge.blurb}`;
    wrap.append(icon);
  }
  return wrap;
}
